<template>
  <ul class="section-toggler" :class="{'section-toggler_justify': justify}">
    <li class="section"
        v-for="(tab,i) in tabs"
        :class="{'active': tab.active}"
        @click="toggleActive(tab, i)"
        :key="tab.id">
      {{tab.name}}
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'sectionToggler',
    props: {
      tabs: Array,
      justify: Boolean,
      isProjectEdit: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    methods: {
      toggleActive(tab, i) {
        if(this.isProjectEdit) {
          this.$emit('toggleProjectEdit', {tab: tab.component, index: i})
        } else {
          this.$emit('toggle', {tab: tab.component, index: i})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .section-toggler {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 -15px;
    position: relative;
    margin-bottom: 40px;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background: $lightGrey;
      bottom: 0;
      left: -30px;
    }
  }

  .section-toggler_justify {
    justify-content: space-between;
  }

  .section {
    font-family: $mm;
    font-size: 14px;
    color: $darkBlue;
    padding-bottom: 21px;
    position: relative;
    margin: 0 15px;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 3px;
      background: none;
      bottom: 0;
      left: 0;
    }
  }

  .active {
    &::before {
      background: $lightBlue;
    }
  }
</style>
